module.exports = __webpack_public_path__ + "img/logo-uaysen_patagonia_blanco_sin_fondo.6b9b6b9c.png";